Message3D = function( scene, dispatcher, points, sprite ) {
	/*---------------------------------------------------
		VARIABLES
	--------------------------------------------------*/
	this.message = "";
	this.scene = scene;
	this.dispatcher = dispatcher;
	
	this.messageList = [];
	this.lineList = [];
	
	this.points_letter = points; //number of points per letter.;
	this.point_vector_list = []; //Stores points per letter.;
	this.totalPoints = 0;
	this.sprite = sprite;
	
	this.pointScale = 7;

	this.radius = 410;

	this.lineMax = 23;

	this.messageVisible = false;
	this.start =  Date.now();
	this.maxArea = 950;

	this.init();

};

Message3D.prototype = {
    
	constructor: Message3D,
    
    /*---------------------------------------------------
		INITIALIZER
	--------------------------------------------------*/
	
	init : function(){
		if(Detectizr.device.type === "tablet"){
			this.pointScale = 9;
		}
		this.getAssets();
		this.bindXEvents();
	},
	
	bindXEvents : function(){
		this.dispatcher.addEventListener( EVENTS.SHOW_EXPLORE, this.destroyMessage.bindX( this ) );
		this.dispatcher.addEventListener( EVENTS.SHOW_MESSAGE_3D, this.showMessage.bindX( this ) );
		this.dispatcher.addEventListener( EVENTS.HIDE_MESSAGE_3D, this.hideMessage.bindX( this ) );
		this.dispatcher.addEventListener( EVENTS.DESTROY_MESSAGE_3D, this.destroyMessage.bindX( this ) );
		this.dispatcher.addEventListener( EVENTS.CREATE_MESSAGE_3D, this.createMessage.bindX( this ) );
	},

	getAssets : function(){
		this.sprite = new THREE.Texture( app.loader.getItem( "star" ) );
		this.sprite.needsUpdate = true;
		this.font = new THREE.Font();
		this.font.data = app.loader.getItem( "font" );
	},

	splitLines :function(){
		this.lines = [ "" ];
		this.wordSplit = this.message.split(' ');
		var currentLine = 0;
		while ( this.wordSplit[ 0 ] ) {
			var word = this.wordSplit.shift();
			var lineUpdate = this.lines[currentLine] + word + " ";
			if(lineUpdate.length < this.lineMax){
				this.lines[currentLine] = lineUpdate;
			}else{
				currentLine++;
				this.lines[ currentLine ] = word + " ";
			}
		}
	},
	
	getLetterPoint : function(){
		this.point_vector_list = [];
		this.totalPoints = 0;
		var geomLists = [];
		var startY = 0;
		var linesNum = this.lines.length;

		if(linesNum > 1){
			startY = -60+( linesNum / 2 ) * 69;
		}
		for( var i = 0; i < linesNum; i++ ) {
			
			var textGeometry = this.getTextGeo( this.lines[ i ] );

			var centerOffset = -0.5 * ( textGeometry.boundingBox.max.x - textGeometry.boundingBox.min.x );
			var numLetters = textGeometry.letterVertices.length;
			var ypos = startY + ( i * -69 );
			
			for(var k = 0; k < numLetters; k++ ){
				
				var geo = this.getTempGeometry( textGeometry.letterVertices[ k ],textGeometry.letterFaces[ k ],centerOffset, ypos );
				
				var base =  ( geo.boundingBox.max.x - geo.boundingBox.min.x );
				var height =  ( geo.boundingBox.max.y - geo.boundingBox.min.y );
				var area = ( base * height ) / 2;

				var multiplier = area / this.maxArea;
				var points = Math.floor( this.points_letter * multiplier )
			
				this.point_vector_list.push( THREE.GeometryUtils.randomPointsInGeometry( geo, points ) );
				
				//GETS RANDOM POINTS//
				this.totalPoints += points;
				
			}
		}
	},
	
	getTempGeometry : function( letterV, letterF, centerOffset, y ){
		//BUILDS LETTER GEOMETRY//
		var numVertices = letterV.length;
		var numFaces = letterF.length;
		var geo = new THREE.Geometry();

		for(var l = 0; l<numVertices; l++ ){
			geo.vertices.push(letterV[l]);
		}
		
		for(var p = 0; p<numFaces; p++){
			geo.faces.push(letterF[p]);
		}

		geo.translate(centerOffset,y,0);
		geo.computeBoundingBox();
		geo.computeVertexNormals();
		return geo;
	},


	getTextGeo : function(copy){
		var textGeoWhole = new THREE.TextGeometry(copy, {
			font : this.font,
			size : 50,
			height : 0,
			curveSegments : 12
		});
		textGeoWhole.computeBoundingBox();
		textGeoWhole.computeVertexNormals();
		return textGeoWhole;
	},

	
	curveGeom : function(){
		this.radius = this.radius * 1.2;//extra 1.2 so the edges dont get curved to much
		for(var i = 0; i < this.geometry.attributes.position.array.length; i+=3){
			this.geometry.attributes.position.array[ i+2 ] = -Math.sqrt(( (this.radius*this.radius) - Math.abs(this.geometry.attributes.position.array[ i ]*this.geometry.attributes.position.array[ i ])));
		}
		this.geometry.attributes.position.needsUpdate = true;
	},

	
	createBufferGeometry : function(){
		var positions = new Float32Array( this.totalPoints * 3 );
		var colors = new Float32Array( this.totalPoints * 3 );
		var sizes = new Float32Array( this.totalPoints* 2  );
		var delay = new Float32Array( this.totalPoints * 2 );
		var letter = new Float32Array( this.point_vector_list.length  );
		var alphas = new Float32Array( this.totalPoints  );
		var ind = new Float32Array( this.totalPoints  );
		
		var currentPos = 0;
		var currentPos1 = 0;
		var color = new THREE.Color( 0xffffff );
		var amount = this.point_vector_list.length;
		for (var k = 0; k <this.point_vector_list.length; k++){
			for ( var i = 0, l = this.point_vector_list[ k ].length; i < l; i ++ ) {
						positions[currentPos + (i * 3)] = this.point_vector_list[ k ][ i ].x ;
						positions[currentPos + (i * 3)+1] =  this.point_vector_list[ k ][ i ].y;
						positions[currentPos + (i * 3)+2] = this.point_vector_list[ k ][ i ].z;

						color.setHSL( 0.5 + 0.2 * Math.random()/10, 0.5 + 0.2 * Math.random(), 0.5 + 0.2 * Math.random() );

						color.toArray( colors, currentPos + (i * 3));
						//colors[currentPos + (i * 3)] = 189/255;
						//colors[currentPos + (i * 3)+1] = 236/255;
						//colors[currentPos + (i * 3)+2] = 1;
					//	ind[currentPos1] = Math.random() * 10.0;
						currentPos1++;
			}
			letter[k] = currentPos1;
			currentPos += (this.point_vector_list[k].length * 3);
			
		}

		for( var j = 0; j < this.totalPoints; j ++ ) {
			alphas[ j ] = Math.random() / 10;
		}

		var duration = 2;
		var maxPrefabDelay = 0.25;

		this.totalDuration = letter.length * duration;
		currentPos = 0;
		var currentDelay = 0;

		// give each letter a delay
		for (var p = 0, offset = 0; p < this.totalPoints; p++, offset+=2) {
			if( letter[ currentPos ] <= p ){
				currentPos++;
				currentDelay += maxPrefabDelay;
			}
			// give each point random duration plus delay
			var delayVal = currentDelay + ( Math.random() * 0.4 );
			delay[offset] = delayVal;
			delay[offset+1] = 0.5 + Math.random() * 1.5;
			sizes[offset] = 0; 
			sizes[offset+1] = ( 0.1+ Math.random() * this.pointScale );
			if(offset % 500 === 0) sizes[offset+1] =  this.pointScale * 1.3;
		}
		this.totalDuration = currentDelay + 4;
		this.geometry = new THREE.BufferGeometry();
		this.geometry.addAttribute( 'position', new THREE.BufferAttribute( positions, 3 ) );
		this.geometry.addAttribute( 'customColor', new THREE.BufferAttribute( colors, 3 ) );
		this.geometry.addAttribute( 'size', new THREE.BufferAttribute( sizes, 2 ) );
		this.geometry.addAttribute( 'delay', new THREE.BufferAttribute( delay, 2 ) );
		this.geometry.addAttribute( 'alpha', new THREE.BufferAttribute( alphas, 1 ) );
		//this.geometry.addAttribute( 'ind', new THREE.BufferAttribute( ind, 1 ) );
	},
	
	addAnimDataBufferGeom : function(){
		var positionsStart = new Float32Array( this.totalPoints * 3 );
		var positionsEnd = new Float32Array( this.totalPoints * 3 );

		// calculate the stand and end positions for each point

		for (i = 0; i < this.totalPoints; i++) {
			positionsStart[(i*3)] = Math.random()*500 - Math.random()*500;
			positionsStart[(i*3)+1] = Math.random()*500- Math.random()*500;
			positionsStart[(i*3)+2] = Math.random()*500- Math.random()*500;
			
			positionsEnd[(i*3)] =  this.geometry.attributes.position.array[(i*3)];
			positionsEnd[(i*3)+1] = this.geometry.attributes.position.array[(i*3)+1];
			positionsEnd[(i*3)+2] = this.geometry.attributes.position.array[(i*3)+2] + Math.random()*6- Math.random()*6;

		}

		this.geometry.addAttribute( 'startPosition', new THREE.BufferAttribute( positionsStart, 3 ) );
		this.geometry.addAttribute( 'endPosition', new THREE.BufferAttribute( positionsEnd, 3 ) );
	},

	createIntroTween : function(){
		this.introTw = TweenMax.to(this, this.totalDuration, {ease: Power0.easeIn});
	},
	
	createPointCloud : function(){
		uniforms = {
			color : { value: new THREE.Color( 0xffffff ) },
			texture : { value : this.sprite },
			twTime : { value : 0  } ,
			uTime : { value : 0  } 
		};

		var shaderMaterial = new THREE.ShaderMaterial( {
			uniforms : uniforms,
			vertexShader : document.getElementById( 'vertexshader' ).textContent,
			fragmentShader : document.getElementById( 'fragmentshader' ).textContent,
			blending : THREE.AdditiveBlending,
			depthTest : false,
			transparent : true,
			depthWrite : true
		});

		this.pointCloud = new THREE.Points( this.geometry, shaderMaterial );
		this.pointCloud.frustumCulled = false;
		this.scene.add(this.pointCloud);

		//POSITION CORRECTION;
		if( this.getMeshWidth() > 500 ){
			this.pointCloud.rotation.y = -15 * ( Math.PI / 180 );	
		}

	},
	
	getMeshWidth : function(){
		var helper = new THREE.BoundingBoxHelper( this.pointCloud, 0xff0000 );
		helper.update();
		return ( helper.box.max.x - helper.box.min.x );
	},

	render : function(){

		if(!this.messageVisible) return;
		this.alphas = this.pointCloud.geometry.attributes.alpha;
		this.pointCloud.material.uniforms.twTime.value = this.introTw.time();
		this.scaleAnim();
	},

	positionAnim : function(){
		var position = this.pointCloud.geometry.attributes.position;
		var positionS = this.pointCloud.geometry.attributes.startPosition;
		var positionE = this.pointCloud.geometry.attributes.endPosition;
		var delay = this.pointCloud.geometry.attributes.delay;
		var count = this.alphas.count;

		for( var i = 0, j = 0,k = 0; i < count; i ++,j += 2,k += 3 ) {
	
			var alpha =  Math.clamp( this.introTw.time() - delay.array[ j ], 0.0,  delay.array[ j + 1 ]) /  delay.array[ j + 1  ];
			this.alphas.array[ i ] =  0.2 + alpha;
			position.array[ k ] = positionS.array[ k ] +(positionE.array[k] - positionS.array[ k ]) * alpha;
			position.array[ k + 1 ] = positionS.array[ k + 1 ] +(positionE.array[ k + 1 ] - positionS.array[ k + 1 ]) * alpha;
			position.array[ k + 2 ] = positionS.array[ k + 2 ] +(positionE.array[ k + 2 ] - positionS.array[ k + 2 ]) * alpha;

		}

		this.pointCloud.geometry.attributes.alpha.needsUpdate = true;
		this.pointCloud.geometry.attributes.position.needsUpdate = true;
	},



	scaleAnim : function(){
		var time = Date.now() * 0.005;
		var sc,h1,l1,sc1 = 0;
		var sizes = this.pointCloud.geometry.attributes.size.array;

		var l = this.pointCloud.geometry.attributes.size.array.length;
		for ( var i = 0; i < l; i+=2 ) {
			//sc =  ( 1 + Math.sin( 0.4 * i + time ) );
			sizes[ i ] =  (sizes[ i + 1] + 0.1 ) + sizes[ i + 1] * Math.sin( 0.1 * i / 2 + time );//this.pointScale * sc;
		}
		this.pointCloud.geometry.attributes.size.needsUpdate = true;
		
	},

	/*---------------------------------------------------
		EVENT HANDLERS
	--------------------------------------------------*/

	showMessage : function( event, data ) { 
		this.messageVisible = true;
		this.pointCloud.visible = true;
	},
	
	hideMessage : function( event, data) {
		this.messageVisible = false;
		this.pointCloud.visible = false;
	},
	
	destroyMessage : function( event, data ) {
		if(this.messageVisible === false) return;
		this.messageVisible = false;
		
		this.introTw.kill();
		this.introTw = null;

		this.pointCloud.material.dispose();
		
		this.pointCloud.geometry.dispose();
		this.geometry.dispose();
		this.geometry = null;
		
		this.scene.remove( this.pointCloud );
		this.pointCloud = null;
	},
	
	createMessage : function( event, data ) {
		if(this.pointCloud !== null) this.destroyMessage();
		this.radius = 410;
		this.totalPoints = 0;
		this.message = data.message;

		this.splitLines();
		this.getLetterPoint();
		this.createBufferGeometry();
		this.curveGeom();
		this.addAnimDataBufferGeom();
		this.createPointCloud();
		this.createIntroTween();

		this.messageVisible = true;
	}

	/*--------------------------------------------------*/
	/*--------------------------------------------------*/
};


